import {
	GOALS_APP_READING_MODE_PATH,
	PROJECTS_APP_READING_MODE_PATH,
	READING_MODE_PAGE,
	READING_MODE_PATH,
} from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const readingModeRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: READING_MODE_PAGE,
	path: READING_MODE_PATH,
});

export const goalsAppReadingModeRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: READING_MODE_PAGE,
	path: GOALS_APP_READING_MODE_PATH,
});

export const projectsAppReadingModeRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: READING_MODE_PAGE,
	path: PROJECTS_APP_READING_MODE_PATH,
});
